<div
  #map
  style="width: 100%; height: 100%"
  class="md:min-h-[23rem] min-h-[11rem] rounded-lg"
></div>
